export const CAKE_BNB_LP_MAINNET = '0x0eD7e52944161450477ee417DE9Cd3a859b14fD0'
export const CAKE_ALL_LP_MAINNET = '0x119751597FE282615ac8dd5323577cc9b2728102'
